import { DialogStepSchema } from '@feedyou-ai/feedbot-schema'

import { Search } from '../../../types'
import { createConfigs, searchMutableObject } from '../../../../../features/flowSearch'

export const search: Search<DialogStepSchema> = (step, query) => {
  return searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      dialog: ['dialog'],
      text: ['condition']
    })
  )
}
